import { branch, compose, renderNothing } from 'recompose';
import { prop } from 'ramda';
import { connect } from 'react-redux';
import { omitProps } from '../../../common/helpers/props';
import { getHasPaymentOpened } from '../reducer/currentPayment/selectors';
import { closePayment } from '../reducer/currentPayment/actions';
import BackButton from '../components/BackButton';

const BackButtonContainer = compose(
  connect(
    state => ({
      noPaymentOpened: !getHasPaymentOpened(state),
    }),
    { onClick: closePayment },
  ),
  branch(
    prop('noPaymentOpened'),
    renderNothing,
  ),
  omitProps(['noPaymentOpened']),
)(BackButton);

export default BackButtonContainer;
